export * from './tabs-layout.component';
export * from './tabs-layout.module';
